import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { clearfix, toVw, toVwMobile, toVwTablet } from '../../../utils/styles';
import mq from '@/utils/media-queries';

const Styled = styled.div`
  margin-bottom: ${toVw(252)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(245)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(252)};
  `)};
`;

const SERVICE_MARGIN_BOTTOM = 186;

const Service = styled.div`
  display: flex;
  margin-bottom: ${toVw(SERVICE_MARGIN_BOTTOM)};
  ${clearfix};

  &:last-child {
    margin-bottom: 0;
  }

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(SERVICE_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(180)};
  `)};
`;

const NAME_WIDTH = 288;

const Name = styled.div`
  width: ${toVw(NAME_WIDTH)};
  color: ${props => props.theme.colorMinor};
  box-sizing: border-box;
  padding-right: 30px;

  ${mq.tablet(css`
    width: ${toVwTablet(NAME_WIDTH)};
  `)};

  ${mq.mobile(css`
    width: ${toVwMobile(252)};
  `)};
`;

const Groups = styled.div`
  ${clearfix};
`;

const Group = styled.div`
  float: left;

  &:first-child {
    width: ${toVw(432)};
  }

  ${mq.tablet(css`
    float: none;

    &:first-child {
      width: 100%;
    }
  `)};
`;

const Services = ({ items }) => (
  <Styled>
    {items.map((service, index) => (
      <Service key={index} data-test="service">
        <Name>{service.name}</Name>
        <Groups>
          {service.items.map((group, index) => (
            <Group key={index}>
              {group.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </Group>
          ))}
        </Groups>
      </Service>
    ))}
  </Styled>
);

Services.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Services;



// WEBPACK FOOTER //
// ./src/scenes/Approach/components/Services.js